export default __webpack_public_path__ + "static/media/long-arrow-alt-right.88184648.svg";